// extracted by mini-css-extract-plugin
module.exports = {"listGroup":"UserList_listGroup__1zs7T","deleteIcon":"UserList_deleteIcon__9WDlt","bagde":"UserList_bagde__3uv7G"};